const CONFIG_ROL = {
  comprador: {
    empresaValor: (item) => item.empidComprador,
    empresaLabel: (item) => item.compradorRazonSocial || item.compradorNombre,
    usuarioValor: (item, p) => p.idComprador,
    usuarioLabel: (item) => item.compradorNombre
  },
  vendedor: {
    empresaValor: (item) => item.empidVendedor,
    empresaLabel: (item) => item.vendedorRazonSocial || item.vendedorNombre,
    usuarioValor: (item) => item.idVendedor,
    usuarioLabel: (item) => item.vendedorNombre
  }
}

export const construirArbolEmpresaUsuario = (pedidos, rol) => {
  const { empresaValor, empresaLabel, usuarioValor, usuarioLabel } = CONFIG_ROL[rol]
  const empresas = new Map()

  pedidos.forEach((p) => {
    ;(p.pedidoItems ?? []).forEach((item) => {
      const empVal = empresaValor(item, p)
      const usrVal = usuarioValor(item, p)
      if (empVal === undefined || empVal === null) {
        return
      }

      if (!empresas.has(empVal)) {
        empresas.set(empVal, {
          valor: empVal,
          label: empresaLabel(item, p),
          usuarios: new Map()
        })
      }

      if (usrVal !== undefined && usrVal !== null) {
        empresas.get(empVal).usuarios.set(usrVal, {
          valor: usrVal,
          label: usuarioLabel(item, p)
        })
      }
    })
  })

  return [...empresas.values()]
    .map((emp) => ({
      ...emp,
      usuarios: [...emp.usuarios.values()]
    }))
    .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
}
